export default "__VITE_ASSET__Cx97EKfL__"